import React, { ForwardedRef, forwardRef, useId } from "react";
import classNames from "classnames";
import { CheckboxProps } from "./typer";

function Component(
  { id, label, description, description2, description3, sm, ...rest }: CheckboxProps,
  ref: ForwardedRef<HTMLInputElement>,
) {
  const hasDescription =
    description !== undefined || description2 !== undefined || description3 !== undefined;
  const descriptionId = useId();

  return (
    <>
      <input type="checkbox" id={id} ref={ref} {...rest} />
      <label
        className={classNames("svv-form-label", {
          "svv-label-grid": hasDescription,
          "svv-form-input--sm": sm,
        })}
        htmlFor={id}
      >
        <span>{label}</span>
        {hasDescription && (
          <span id={descriptionId}>
            {description && <span className="svv-label-description">{description}</span>}
            {description2 && <span className="svv-label-description">{description2}</span>}
            {description3 && <span className="svv-label-description">{description3}</span>}
          </span>
        )}
      </label>
    </>
  );
}

export const SVVCheckbox = forwardRef<HTMLInputElement, CheckboxProps>(Component);

SVVCheckbox.displayName = "SVVCheckbox";
